import { render, staticRenderFns } from "./Benchmarking.vue?vue&type=template&id=62c7dedb&scoped=true"
import script from "./Benchmarking.vue?vue&type=script&lang=js"
export * from "./Benchmarking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c7dedb",
  null
  
)

export default component.exports